import React from 'react'; 
import { EditOutlined, SearchOutlined} from '@ant-design/icons';
import DeliveryFeeForm from './DeliveryFeeDetailsForm';
import { useState } from 'react';
import NewEditableGrid from '../../shared/NewEditableGrid';
import { useEffect } from 'react';
import { deleteDeliveryFee, getDeliveryFees, getDeliveryMethods, saveDeliveryFee, saveDeliveryMethod } from '../../../networking/NetworkingBankNotes';
import AlertBox from '../../shared/AlertBox';
import LoadingBox from '../../shared/LoadingBox';
import { Breadcrumb } from 'antd';
import DeliveryFeeDetailsScreen from './DeliveryFeeDetailsScreen';

const DeliveryFeeScreen = () => {
    
    const [columnDetail, setColumnDetail] = useState([])
    const [deliveryMethods, setDeliveryMethods] = useState([]);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [activeTab1, setActiveTab1] = useState('uk-active');
    const [activeTab2, setActiveTab2] = useState('uk-disabled');
    const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState({});
const defaultRowsSize = window.DEFAULT_ROWS_SIZE??20;

    const loadDeliveryMethods = async() => {
        const deliveryMethodsResponse = await getDeliveryMethods('')

        if(deliveryMethodsResponse && deliveryMethodsResponse.DeliveryMethod) {
            const list = deliveryMethodsResponse.DeliveryMethod.filter(dm => dm.DisplayOrder > 0);
            setDeliveryMethods(list);
            setColumnDetail(JSON.parse(deliveryMethodsResponse.columnDetail));   
        }
    }

    useEffect(()=>{     

        loadDeliveryMethods();

    },[])
            
    const updateDeliveryMethod = async(record, row) =>{

        const objDeliveryMethod ={
            DeliveryFeeID : record.id,
            DeliveryFeeDescription: record.Description,
            BuySell: record.BuySell,
            UserID:  localStorage.getItem('UserID')
        }

        setLoading(true);
        const response = await saveDeliveryMethod(objDeliveryMethod);

        if(Number(response.httpStatusCode) === 200){
            loadDeliveryMethods();
            setSelectedDeliveryMethod({});
        }
        else
        {
            console.log(response);
            setAlertTitle('Error');
            setAlertMessage(response.ErrorMessage);
            setShowAlert(true);
        }

         setLoading(false);
    }

    const onClicTab = () =>{
        setActiveTab1('uk-active');
        setActiveTab2('uk-disabled');
    }

    const viewDetails = (obj) =>{
        console.log(obj);
        setSelectedDeliveryMethod(obj);
        setActiveTab1('');
        setActiveTab2('uk-active');
    }   

    const getBreadcrumb = () =>{
        let breadcrumb = [];
    
        if (activeTab1 === 'uk-active') {
            breadcrumb.push(
                <Breadcrumb.Item className="breadcrumb-item-bold">Delivery Methods</Breadcrumb.Item>
            );
        } else if (activeTab2 === 'uk-active') {
            breadcrumb.push(
                <Breadcrumb.Item className="breadcrumb-item" onClick={onClicTab}>Delivery Methods</Breadcrumb.Item>
            );
            breadcrumb.push(
                <Breadcrumb.Item className="breadcrumb-item-bold">Delivery Method - {selectedDeliveryMethod.Description}</Breadcrumb.Item>
            );
        }

        return breadcrumb;
    }

    const getScreen = () =>{
        let screen = [];
    
        if (activeTab1 === 'uk-active') {
            screen.push(
                <NewEditableGrid
                    data={deliveryMethods}
                    columnDetails={columnDetail}
                    isEditable={true}                    
                    editSaveFunction={updateDeliveryMethod}
                    useExportButton={true}
                    tableName="Delivery Methods"
                    useIcons={true} 
                    canAdd={true}
                    pageRowsSize={defaultRowsSize}
                    addSaveFunction={updateDeliveryMethod}
                    dynamicActions={[{name: 'Fees', function: viewDetails, isIcon: true, icon: <SearchOutlined />}]}/>
            );
        } else if (activeTab2 === 'uk-active') {
            screen.push(
                <DeliveryFeeDetailsScreen selectedDeliveryMethod={selectedDeliveryMethod}/>
            );
        }

        return screen;
    }

        return(
            <> 
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        {getBreadcrumb()}
                    </Breadcrumb>
                </div>
                <div className="uk-margin">
                    {getScreen()}
                </div>  
                <AlertBox open={showAlert} onClose={()=>setShowAlert(false)} title={alertTitle} message={alertMessage} type="Ok" okClick={()=>setShowAlert(false)}/>
                <LoadingBox loading={loading}/>
            </>
        );
    
}

export default DeliveryFeeScreen